import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  slug = "",
  image,
  type = "article",
}) {
  const siteName = "Mini Miles Adventures";
  const defaultDescription =
    "Following quiet backroads, national parks, and unexpected places across the country.";
  const defaultImage = "https://amazonaws.com";
  const siteUrl = "https://www.minimilesadventures.com"; // Replace with your live URL track

  const seoTitle = `${title} | ${siteName}`;
  const seoDescription = description || defaultDescription;
  const seoImage = image || defaultImage;
  const seoUrl = `${siteUrl}${slug}`;

  return (
    <Helmet>
      {/* Standard HTML Metadata Elements */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <link rel="canonical" href={seoUrl} />

      {/* Facebook & Open Graph Protocols (Social Media Previews) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter Cards Metrics Networks Previews */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
    </Helmet>
  );
}
